module.exports = __webpack_public_path__ + "static/img/nothing@2x.968b179.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/nothing@2x.png
// module id = +sZ3
// module chunks = 19